import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'

const StyledSpeedDial = ({model = [], callBack = () => {}}) => {
    useSignals()
    const visible = useSignal(false)
    return (
        <div className="fixed bottom-0 right-0 mb-4 mr-4 z-5">
            <div id="speed-dial" className="flex flex-column align-items-end">
                {model?.length > 0 && (
                    <div
                        className={`${
                            visible.value ? 'flex flex-column ' : 'hidden'
                        } bg-white shadow-4 mb-2`}>
                        <div
                            className="flex align-items-center justify-content-between w-full p-3"
                            style={{
                                borderTopRightRadius: '0.5rem',
                                borderTopLeftRadius: '0.5rem',
                                backgroundColor: '#0f766e',
                            }}>
                            <div className="mr-4">
                                <h5 className="font-semibold text-white">
                                    <span>
                                        <i className="pi pi-bolt mr-2"></i>
                                    </span>
                                    Quick Actions
                                </h5>
                            </div>
                            <div
                                className="cursor-pointer mb-2"
                                onClick={() =>
                                    (visible.value = !visible.value)
                                }>
                                <i className="pi pi-chevron-down text-white"></i>
                            </div>
                        </div>
                        <ul className="list-none m-0 p-0">
                            {model?.map(item => (
                                <li
                                    key={item?.key}
                                    className="cursor-pointer border-bottom-1 surface-border hover:surface-100">
                                    <div
                                        className="flex align-items-center gap-3 p-3"
                                        onClick={() => callBack(item.key)}>
                                        <div className="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-green-50 text-green-600">
                                            {item?.icon}
                                        </div>

                                        <span className="font-semibold text-900">
                                            {item?.label}
                                        </span>
                                    </div>
                                </li>
                            ))}
                        </ul>

                        {/* <ul className="list-none flex flex-column align-items-end">
                            {model?.map(item => {
                                return (
                                    <li className="w-max" key={item?.key}>
                                        <div
                                            className="flex align-items-center text-right text-white surface-700 m-2 p-2 border-round-lg cursor-pointer hover:surface-500"
                                            onClick={() => callBack(item.key)}>
                                            {item?.icon}
                                            <h5 className="m-0 font-normal">
                                                {item?.label}
                                            </h5>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul> */}
                    </div>
                )}
                <Button
                    className="border-circle p-speeddial-button"
                    icon={visible.value ? 'pi pi-times' : 'pi pi-plus'}
                    onClick={() => (visible.value = !visible.value)}
                />
            </div>
        </div>
    )
}

export default StyledSpeedDial
